import { useEffect, useRef, useState } from "react";
import { DropBoxItem, DropBoxItemWrapper, DropBoxWrapper } from "./style";

interface DropBoxProps {
  list: { name: string; value: any }[];
  value: any;
  setValue: (value: any) => void;
  isBig?: boolean;
  width?: string;
  label?: string;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}

const isSameValue = (a: any, b: any) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    const sortedA = [...a].map(String).sort();
    const sortedB = [...b].map(String).sort();
    return sortedA.every((item, index) => item === sortedB[index]);
  }
  return a === b;
};

const DropBox = ({
  list,
  value,
  setValue,
  isBig,
  width,
  label,
  isOpen,
  setIsOpen,
}: DropBoxProps) => {
  const selectedItemRef = useRef<HTMLDivElement | null>(null);
  const [isDropOpen, setIsDropOpen] = useState<boolean>(isOpen ?? false);
  const selectedName = list.find((item) =>
    isSameValue(item.value, value),
  )?.name;

  useEffect(() => {
    setIsDropOpen(isOpen ?? false);
  }, [isOpen]);

  useEffect(() => {
    if (isDropOpen && selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({
        block: "center",
        behavior: "auto",
      });
    }

    setIsOpen?.(isDropOpen);
  }, [isDropOpen]);

  return (
    <DropBoxWrapper
      onClick={() => setIsDropOpen(!isDropOpen)}
      isBig={isBig}
      width={width}
    >
      <div className="name">
        <span>{label && !value ? label : selectedName}</span>
        <img src="/image-web/edit/arrow_down.svg" alt="" />
      </div>
      {isDropOpen && (
        <DropBoxItemWrapper isBig={isBig}>
          {list.map((item, index) => (
            <DropBoxItem
              ref={item.value === value ? selectedItemRef : null}
              key={index}
              selected={item.value === value}
              isBig={isBig}
              onClick={() => setValue(item.value)}
            >
              {item.name}
            </DropBoxItem>
          ))}
        </DropBoxItemWrapper>
      )}
    </DropBoxWrapper>
  );
};

export default DropBox;
